// Staff read one fixed, named zone: the console prints every instant in UTC,
// never in the browser's zone or language.
const UTC_STAMP = new Intl.DateTimeFormat("en-US-u-hc-h23", {
  timeZone: "UTC", month: "short", day: "numeric", year: "numeric",
  hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZoneName: "short",
});
// Without an offset the browser would read the text as its own local time.
const OFFSET = /(?:Z|[+-]\d{2}:?\d{2})$/i;

/** An instant as the console prints it, "Nov 3, 2026, 01:00:00 UTC". Text
 *  that is not an instant with an explicit offset prints as served. */
export function formatTimestamp(value: string): string {
  const ms = OFFSET.test(value) ? Date.parse(value) : Number.NaN;
  return Number.isNaN(ms) ? value : UTC_STAMP.format(ms);
}
